<!-- 结果弹窗 -->
<template>
  <div class="result-popup">
    <van-overlay
      :show="show"
      @click="close"
      :lock-scroll="false"
      class="my-overlay"
    >
      <div class="wrapper" @click.stop>
        <img
          v-if="iconMap[iconKey]"
          class="pic"
          :src="iconMap[iconKey]"
          alt=""
        />
        <p class="title">{{ title }}</p>
        <p class="text">{{ message }}</p>
        <p class="tip">可关闭此页面</p>
      </div>
      <van-icon name="close" class="close" @click="close" />
    </van-overlay>
  </div>
</template>
<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      show: false,
      iconMap: {
        0: require(`@/assets/imgs/yunnanPostalWhiteList/success.png`),
        1: require(`@/assets/imgs/yunnanPostalWhiteList/warn.png`),
        2: require(`@/assets/imgs/yunnanPostalWhiteList/error.png`),
      }, // 0:成功，1：警告，2：错误
      iconKey: '',
      title: '',
      message: '',
    }
  },
  methods: {
    close() {
      this.setShow(false)
      this.$emit('result-popup-close')
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.result-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    padding: 10px 15px 30px 15px;
    width: 305px;
    height: 244px;
    box-sizing: border-box;
    background: url("../../../../assets/imgs/yunnanPostalWhiteList/dialog-bg.png")
      no-repeat;
    background-size: 100% auto;
    text-align: center;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    .pic {
      width: 48px;
      margin-bottom: 24px;
    }

    .title {
      margin-bottom: 14px;
      font-size: 24px;
      color: #2a2a2a;
      font-weight: bold;
    }
    .text {
      font-size: 14px;
      color: #000000;
    }
    .tip {
      position: absolute;
      bottom: 23px;
      font-size: 12px;
      color: #999999;
      line-height: 8px;
    }
  }
  .close {
    margin-top: 10px;
    font-size: 35px;
    color: #fff;
    font-weight: 600;
  }
}
</style>
